import React from 'react'
import PropTypes from 'prop-types'
import { Form, FormGroup } from 'react-bootstrap'

import { inject, observer } from "mobx-react"

@inject("store")
@observer
export default class Dropdown extends React.Component {
  render() {
    const { store, field } = this.props
    const { uuid, name, required } = field
    const instance = this.props.instance || 0
    const errorMessage = store.errorFor(uuid, "dropdown", instance)
    const value = store.valueFor(uuid, "dropdown", instance) || ""

    return (
      <FormGroup>
        <Form.Label>{ required ? "*" : "" } {name}</Form.Label>
          <div className="only-pdf">
            { value }
          </div>
          <div className="no-pdf">
            <Form.Select
              value={value}
              onChange={e => { store.setValueFor(uuid, "dropdown", instance, e.target.value) }}
              disabled={!store.editable}
              isInvalid={!!errorMessage}
              >
              <option value="" />
              {field.values.map((option, index) => {
                return (
                  <option key={index} value={option}>{option}</option>
                )
              })}
            </Form.Select>
          </div>
        { errorMessage && <Form.Control.Feedback type="invalid" style={{display: "block"}}>{errorMessage}</Form.Control.Feedback> }
        { field.hint && <Form.Text muted>{field.hint}</Form.Text> }
      </FormGroup>
    )
  }
}
